import React from 'react'

type FlagVariants = 'ENABLED' | 'DISABLED' | 'UNASSIGNED' | undefined

interface ArcadeComponentMigrationFeatureFlags {
  'cash-web-arcade-migration-button'?: FlagVariants
  'cash-web-arcade-migration-input'?: FlagVariants
  'cash-web-arcade-migration-padding-inset'?: FlagVariants
  'cash-web-arcade-migration-avatar'?: FlagVariants
  'cash-web-arcade-migration-loading-icon'?: FlagVariants
  'cash-web-arcade-migration-apps'?: FlagVariants
  'cash-web-arcade-migration-modal'?: FlagVariants
}

export const ArcadeMigrationContext = React.createContext({
  featureFlags: {} as ArcadeComponentMigrationFeatureFlags,
  isArcadeFeatureEnabled: 'UNASSIGNED' as FlagVariants,
})

export const ArcadeComponentMigrationProvider = ({
  isArcadeFeatureEnabled,
  featureFlags,
  children,
}: {
  isArcadeFeatureEnabled: FlagVariants
  featureFlags: ArcadeComponentMigrationFeatureFlags
  children: React.ReactNode
}) => {
  const values = React.useMemo(() => ({ featureFlags, isArcadeFeatureEnabled }), [featureFlags, isArcadeFeatureEnabled])

  return <ArcadeMigrationContext.Provider value={values}>{children}</ArcadeMigrationContext.Provider>
}

export const useArcadeMigrationFeatureFlag = (component: string) => {
  const { featureFlags, isArcadeFeatureEnabled } = React.useContext(ArcadeMigrationContext)
  const flag = `cash-web-arcade-migration-${component}` as keyof ArcadeComponentMigrationFeatureFlags

  // Component flags should explicitly be enabled or disabled to be controlled
  if (component !== 'apps') {
    switch (featureFlags?.[flag]) {
      case 'ENABLED':
        return true
      case 'DISABLED':
        return false
      default:
        break
    }
  }

  // All components should be enabled if the Arcade feature context is not provided or is enabled
  return isArcadeFeatureEnabled !== 'DISABLED' && featureFlags?.['cash-web-arcade-migration-apps'] === 'ENABLED'
}
